module.exports = __webpack_public_path__ + "img/qr_code.efb313f6.jpg";